import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.scss';

const Button = props => (
  <button
    {...props}
    type="button"
    className={cn(styles.button, props.className)}
    style={{ display: props.isShow ? 'block' : 'none' }}
    onClick={e => {
      e.preventDefault();
      props.onAction(e);
    }}
  >
    {props.img && <img alt="" className={styles.image} src={props.img} />}
    {props.text && <span>{props.text}</span>}
  </button>
);

Button.propTypes = {
  isShow: PropTypes.bool,
  onAction: PropTypes.func.isRequired,
  className: PropTypes.string,
  img: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  text: PropTypes.node,
};

Button.defaultProps = {
  text: '',
  img: '',
  isShow: true,
  className: '',
};

export default Button;
